import { render, staticRenderFns } from "./ToccaVinoEditEvent.vue?vue&type=template&id=51e1e8fe&"
import script from "./ToccaVinoEditEvent.vue?vue&type=script&lang=js&"
export * from "./ToccaVinoEditEvent.vue?vue&type=script&lang=js&"
import style0 from "./ToccaVinoEditEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports